import React from "react";
import { Typeahead } from "./Typeahead";

export interface StateSelectProps {
  onChange: (item: string) => void;
  states: string[];
  state?: string;
  type?: "clean" | "input";
  province?: boolean;
  className?: string;
  isCashMoney?: boolean;
}

export const StateSelect = (props: StateSelectProps): JSX.Element => {
  const { states } = props;
  const type = props.type ?? "input";
  const cleanStyle = type == "clean" && {
    color: "brand.lightGreenNew",
    borderColor: "brand.lightGreenNew",
    fontSize: "16px",
    border: "none",
    borderBottom: "solid 1px",
    backgroundColor: "transparent",
    marginBottom: "20px",
    width: "auto",
  };
  return (
    <div
      sx={{
        width: "100%",
        mx: "auto",
        fontSize: "18px",
        borderRadius: "2px",
        backgroundColor: "white",
        maxWidth: "300px",
        fill: type == "clean" ? "brand.lime" : "brand.tealSmallText",
        input: {
          border: type == "clean" ? "none" : "solid 1px",
          borderColor: "brand.tealLargeText",
          backgroundColor: type == "clean" ? "transparent" : "white",
          color: "inherit",
        },
        ul: {
          border: "solid 1px",
          borderColor: "brand.tealLargeText",
        },
        ...cleanStyle,
      }}
      className={props.className}
    >
      <Typeahead
        isCashMoney={props.isCashMoney}
        labelStyle={{
          display: "none",
        }}
        placeholder={`Select ${props.state ? "a different" : "your"} ${
          props.province ? "province" : "state"
        }`}
        label={"Select a State"}
        hint={"Select a State"}
        items={states?.sort()}
        onChange={(state: string) => props.onChange(state.toLowerCase())}
      />
    </div>
  );
};

export default StateSelect;
